"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = require("react-dom");
var index_1 = __importStar(require("../Button/index"));
var index_2 = __importDefault(require("../Modal/index"));
var TextArea_1 = __importDefault(require("../TextArea"));
var removeConfirmElement = function () {
    var target = document.getElementById("react-input-alert");
    if (target && target.parentNode) {
        react_dom_1.unmountComponentAtNode(target);
        target.parentNode.removeChild(target);
    }
};
var inputAlert = function (props) {
    var divTarget = document.createElement("div");
    divTarget.id = "react-input-alert";
    document.body.appendChild(divTarget);
    react_dom_1.render(react_1.default.createElement(InputAlert, __assign({}, props)), divTarget);
};
var InputAlert = /** @class */ (function (_super) {
    __extends(InputAlert, _super);
    function InputAlert(props) {
        var _this = _super.call(this, props) || this;
        _this.handleOnClickButton = function (button) {
            var item = String(button.currentTarget.dataset.id);
            if (_this.props.onClick) {
                _this.props.onClick(item, _this.state.value);
            }
            _this.close();
        };
        _this.close = function () {
            removeConfirmElement();
        };
        _this.buttons = function () {
            var buttons = _this.props.buttons.map(function (item) {
                return (react_1.default.createElement(index_1.default, { variant: item.variant || index_1.ButtonVariant.SecondaryBlue, key: item.label, "data-id": item.id, onClick: _this.handleOnClickButton }, item.label));
            });
            return react_1.default.createElement("div", { className: "buttons" }, buttons);
        };
        _this.textChanged = function (e) {
            _this.setState({
                value: e.currentTarget.value,
            });
        };
        _this.state = {
            value: props.defaultText || "",
        };
        return _this;
    }
    InputAlert.prototype.componentWillUnmount = function () {
        if (this.props.willUnmount) {
            this.props.willUnmount();
        }
    };
    InputAlert.prototype.render = function () {
        var _a = this.props, message = _a.message, width = _a.width, _b = _a.singleRow, singleRow = _b === void 0 ? false : _b, placeholder = _a.placeholder;
        var rows = singleRow ? 1 : 5;
        return (react_1.default.createElement(index_2.default, { header: message, allowToClose: false, open: true, buttons: this.buttons, width: width },
            react_1.default.createElement("div", { style: { padding: "10px" } },
                react_1.default.createElement(TextArea_1.default, { placeholder: placeholder, value: this.state.value, onChange: this.textChanged, rows: rows }))));
    };
    return InputAlert;
}(react_1.default.Component));
exports.default = inputAlert;
//# sourceMappingURL=index.js.map